<template>
  <div>
    <z-mantenedor
      ref="mantenedor"
      v-model="items"
      :botones-listar="[
        {
          title: 'Bitácora',
          icon: 'mdi-file-search-outline',
          click: dialogBitacora,
          posicion: 'derecha',
        },
        {
          title: 'Derivar',
          icon: 'mdi-file-send-outline',
          click: dialogDerivar,
          posicion: 'derecha',
          disabled: (v) => v.estado === 10,
          visible: (v) => !$auth.can(['mesa-de-ayuda']),
        },
        {
          title: 'Escalar a mesa de ayuda',
          icon: 'mdi-face-agent',
          click: dialogEscalar,
          posicion: 'derecha',
          disabled: (v) => !!v.fecha_escalado || v.estado === 10,
          visible: (v) => !$auth.can(['mesa-de-ayuda']),
        },
      ]"
      :campo-titulo-dialog="(v) => $payload.tipoTramiteOirs(v.tramite_id)"
      :campo-subtitulo-dialog="(v) => '#' + v.id"
      :headers="headers"
      :query="query"
      url="/documentacion/oirs"
      search-url="/documentacion/oirs/search"
      search-method="post"
      campo-titulo-dialog-crear="Crear ticket"
      search-inicial
      max-width="900"
      disable-view
      disable-edit
      disable-delete
      texto-hits="%s tickets."
      texto-no-hit="No se encontraron tickets."
      texto-un-hit="Un ticket."
      @created="$emit('notificar', 'Ticket de atención ciudadano creado.')"
      @deleted="$emit('notificar', 'Ticket de atención ciudadano eliminado.')"
      @updated="$emit('notificar', 'Ticket de atención ciudadano guardado.')"
      @created:error="$emit('notificar:error', 'Error al intentar crear.')"
      @update:error="$emit('notificar:error', 'Error al intentar guardar.')"
      @deleted:error="$emit('notificar:error', 'Error al intentar eliminar.')"
    >
      <template #buscador="{ loading: loadingSearch, search }">
        <v-form @submit.prevent="search">
          <v-row dense>
            <v-col cols="12" sm="5" md="3">
              <z-input
                v-model="query.filter.tipo"
                :items="payloadItemsTipoOirs"
                tipo="select"
                label="Tipo"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="7" md="6">
              <z-input
                v-model="query.filter.categoria"
                :items="$itemsCategoriasOirs"
                tipo="select"
                label="Categoría"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="5" md="3">
              <z-input
                v-model="query.filter.estado"
                :items="payloadItemsEstadoOirs"
                tipo="select"
                label="Estado"
                clearable
              />
            </v-col>

            <v-col cols="12" sm="7" md="6">
              <z-input
                v-model="query.filter.tramite_id"
                :items="$itemsTramitesOirs"
                tipo="autocomplete"
                label="Tramite"
                clearable
              />
            </v-col>

            <v-col cols="6" sm="4" md="2">
              <z-input v-model="query.filter.id" type="number" label="Número" />
            </v-col>

            <v-col v-if="$auth.can(['mesa-de-ayuda'])" cols="6">
              <z-input
                v-model="query.filter.institucion_id"
                :items="payloadItemsInstituciones"
                tipo="autocomplete"
                label="Institución"
                clearable
              />
            </v-col>

            <v-col class="text-right">
              <z-btn :loading="loadingSearch" color="primary" outlined type="submit">
                Actualizar
              </z-btn>
            </v-col>
          </v-row>
        </v-form>
      </template>

      <template #item.estado="{ value }">
        <z-chip :color="value === 10 ? 'grey' : value === 5 ? 'warning' : 'info'" small outlined>
          {{ $payload.estadoOirs(value) }}
        </z-chip>
      </template>

      <template #item.id="{ item }">
        {{ $payload.tipoOirs(item.tipo) }}
        <span class="text-caption text--secondary"> #{{ item.id }} </span>
      </template>

      <template #item.tramite_id="{ item }">
        {{ $payload.categoriaOirs(item.categoria) }}
        <div class="text-caption text--secondary">
          {{ $payload.tipoTramiteOirs(item.tramite_id) }}
        </div>
      </template>
    </z-mantenedor>

    <v-dialog
      v-model="dialogBitacoraVisible"
      persistent
      width="700"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card class="pr-8">
        <dialog-toolbar @close="dialogBitacoraVisible = false">
          {{ $payload.categoriaOirs(itemActivo.categoria) }}
          <span class="text--secondary text-caption pl-1 pt-1"> #{{ itemActivo.id }} </span>
        </dialog-toolbar>

        <v-card-text>
          <v-card>
            <v-card-text>
              <v-simple-table>
                <tbody>
                  <tr>
                    <th>Tipo</th>
                    <td>{{ $payload.tipoOirs(itemActivo.tipo) }}</td>
                  </tr>
                  <tr>
                    <th>Categoría</th>
                    <td>{{ $payload.categoriaOirs(itemActivo.categoria) }}</td>
                  </tr>
                  <tr>
                    <th>Trámite</th>
                    <td>{{ $payload.tipoTramiteOirs(itemActivo.tramite_id) }}</td>
                  </tr>
                  <tr v-if="itemActivo.institucion_id !== itemActivo.institucion_id_receptora">
                    <th>Municipalidad responsable</th>
                    <td>{{ $payloadStatic.municipalidad(itemActivo.institucion_id).nombre }}</td>
                  </tr>
                  <tr>
                    <th>Municipalidad receptora</th>
                    <td>
                      {{ $payloadStatic.municipalidad(itemActivo.institucion_id_receptora).nombre }}
                    </td>
                  </tr>
                  <tr>
                    <th>Fecha</th>
                    <td>{{ $formato.fechaHora(itemActivo.created_at) }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <v-card v-if="itemActivo.ciudadano_id" class="mt-4">
            <v-card-title> Ciudadano </v-card-title>
            <v-card-text>
              <v-simple-table>
                <tbody>
                  <tr>
                    <th>Nombre</th>
                    <td>{{ itemActivo.nombres }} {{ itemActivo.apellidos }}</td>
                  </tr>
                  <tr>
                    <th>RUT</th>
                    <td>{{ $formato.rut(itemActivo.ciudadano_id) }}</td>
                  </tr>
                  <tr>
                    <th>Correo electrónico</th>
                    <td>{{ itemActivo.email }}</td>
                  </tr>
                  <tr>
                    <th>Teléfono</th>
                    <td>{{ itemActivo.telefono }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-text>
          <v-timeline
            dense
            :class="{
              'ml-n12': $vuetify.breakpoint.xsOnly,
              'ml-n4': $vuetify.breakpoint.smAndUp,
            }"
          >
            <v-slide-x-reverse-transition group hide-on-leave>
              <v-timeline-item key="contenido" color="primary" small fill-dot>
                <v-card>
                  <v-card-title> {{ itemActivo.nombres }} {{ itemActivo.apellidos }} </v-card-title>
                  <v-card-text class="mt-n6">
                    <v-row dense>
                      <v-col>
                        {{ itemActivo.email }}
                      </v-col>
                      <v-col>
                        {{ itemActivo.telefono }}
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-text style="white-space: pre-line">
                    {{ itemActivo.contenido }}
                  </v-card-text>

                  <v-card-text class="text-caption">
                    {{ $formato.fechaHora(itemActivo.created_at) }}
                  </v-card-text>
                </v-card>
              </v-timeline-item>

              <v-timeline-item
                v-for="bitacora in itemActivo.bitacoras"
                :key="bitacora.id"
                :color="bitacora.ciudadano_id ? 'primary' : 'terciario'"
                small
                fill-dot
              >
                <v-card :color="bitacora.privado ? 'fondo3' : null">
                  <v-card-title>
                    <template v-if="bitacora.user_id_mesa_de_ayuda"> Mesa de ayuda </template>
                    <template v-else-if="bitacora.user_id && bitacora.institucion_id">
                      {{ $payloadStatic.municipalidad(bitacora.institucion_id).nombre }}
                    </template>
                    <template v-else>
                      {{
                        bitacora.user_id
                          ? 'Municipalidad'
                          : itemActivo.nombres + ' ' + itemActivo.apellidos
                      }}
                    </template>
                    <v-icon v-if="bitacora.privado" class="mr-1" color="warning" right>
                      mdi-alert
                    </v-icon>
                  </v-card-title>
                  <v-card-subtitle v-if="bitacora.privado">
                    Mensaje privado, no es visible por el solicitante del ticket.
                  </v-card-subtitle>
                  <v-card-text style="white-space: pre-line">
                    {{ bitacora.contenido }}
                  </v-card-text>
                  <v-card-text class="text-caption">
                    {{ $formato.fechaHora(bitacora.updated_at) }}
                  </v-card-text>
                </v-card>
              </v-timeline-item>
              <v-timeline-item
                v-if="itemActivo.estado !== 10"
                key="agregar"
                color="info"
                small
                fill-dot
              >
                <v-card>
                  <v-card-title> Nuevo mensaje </v-card-title>
                  <v-card-text>
                    <v-row v-if="itemActivo.ciudadano_id">
                      <v-col class="d-flex justify-space-between">
                        <z-input
                          v-model="form.privado"
                          tipo="checkbox"
                          label="¿Mensaje privado?"
                          hide-details
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <z-input
                          v-model.trim="form.contenido"
                          :background-color="form.privado ? 'fondo3' : undefined"
                          tipo="textarea"
                          label="Agregar nuevo mensaje"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="d-flex justify-space-between">
                        <z-input
                          v-model="form.cerrar"
                          :disabled="form.privado"
                          tipo="checkbox"
                          label="Cerrar y marcar como resuelto"
                        />
                        <v-spacer />
                        <z-btn color="primary" :disabled="!form.contenido" @click="agregarMensaje">
                          Guardar
                          {{ form.privado ? ' mensaje privado' : '' }}
                          {{ form.cerrar ? ' y cerrar' : '' }}
                        </z-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-slide-x-reverse-transition>
          </v-timeline>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined color="secondary" @click="dialogBitacoraVisible = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEscalarVisible" persistent width="600">
      <v-card>
        <dialog-toolbar @close="dialogEscalarVisible = false">
          Escalar a mesa de ayuda
          <span class="text--secondary text-caption pl-1 pt-1"> #{{ itemActivo.id }} </span>
        </dialog-toolbar>
        <v-card-subtitle>
          Con esta opción, el ticket será compartido con la mesa de ayuda.
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col>
              <z-input
                v-model.trim="formEscalar.mensaje_a_mesa_de_ayuda"
                tipo="textarea"
                label="Mensaje a la mesa de ayuda"
                maxlength="10000"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex justify-space-between">
              <v-spacer />
              <z-btn
                color="primary"
                :disabled="!formEscalar.mensaje_a_mesa_de_ayuda"
                @click="escalar"
              >
                Escalar a mesa de ayuda
              </z-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDerivarVisible" persistent width="600">
      <v-card>
        <dialog-toolbar @close="dialogDerivarVisible = false">
          Derivar a SUBDERE
          <span class="text--secondary text-caption pl-1 pt-1"> #{{ itemActivo.id }} </span>
        </dialog-toolbar>
        <v-card-text>
          <v-row>
            <v-col>
              <z-input
                v-model.trim="formDerivar.mensaje_derivacion"
                tipo="textarea"
                label="Mensaje de derivación"
                maxlength="10000"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="d-flex justify-space-between">
              <v-spacer />
              <z-btn color="primary" :disabled="!formDerivar.mensaje_derivacion" @click="derivar">
                Derivar
              </z-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ZBtn from '@/components/ZBtn'
import ZMantenedor from '@/components/ZMantenedor'
import ZInput from '@/components/Input/ZInput'
import ZChip from '../../../components/ZChip'
import { mdiArrowLeft, mdiClose } from '@mdi/js'
import DialogToolbar from '@/components/DialogToolbar'

export default {
  components: { DialogToolbar, ZChip, ZInput, ZMantenedor, ZBtn },
  data() {
    return {
      svg: {
        mdiArrowLeft,
        mdiClose,
      },
      loading: false,
      items: [],
      itemActivo: {},
      formDerivar: {},
      formEscalar: {},
      form: {
        privado: false,
        cerrar: false,
        contenido: '',
      },
      dialogBitacoraVisible: false,
      dialogDerivarVisible: false,
      dialogEscalarVisible: false,
      query: {
        include: 'bitacoras',
        paginationDisabled: true,
        filter: {
          estado: null,
          categoria: null,
          institucion_id: this.$auth.can(['mesa-de-ayuda'])
            ? null
            : this.$auth.user().institucion_id,
        },
        sort: {
          0: { field: 'updated_at', direction: 'desc' },
        },
      },
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Tipo',
          value: 'id',
        },
        {
          text: 'Categoría',
          value: 'tramite_id',
        },
        {
          text: 'Fecha',
          value: 'created_at',
          formatter: (v) => this.$formato.fecha(v),
        },
        {
          text: 'Última edición',
          value: 'updated_at',
          formatter: (v) => this.$formato.fechaHora(v),
          visible: this.$vuetify.breakpoint.mdAndUp,
        },
        {
          text: 'Estado',
          value: 'estado',
        },
      ]
    },
  },
  watch: {
    'form.privado': function (privado) {
      if (privado) {
        this.form.cerrar = false
      }
    },
  },
  methods: {
    dialogBitacora(item) {
      this.itemActivo = item
      this.dialogBitacoraVisible = true
      this.form = {}
    },
    dialogDerivar(item) {
      this.itemActivo = item
      this.dialogDerivarVisible = true
      this.formDerivar = {
        institucion_id: null,
        mensaje_derivacion: '',
      }
    },
    dialogEscalar(item) {
      this.itemActivo = item
      this.dialogEscalarVisible = true
      this.formEscalar = {
        mensaje_a_mesa_de_ayuda: '',
      }
    },
    derivar() {
      this.loading = true
      this.dialogDerivarVisible = false
      this.formDerivar.institucion_id = 60515000
      // agregarMensaje() ????
      this.$axios
        .patch(`documentacion/oirs/${this.itemActivo.id}`, this.formDerivar)
        .then((response) => {
          const oirs = response.data.data
          console.log(oirs)
          // TODO: Quitar item de la lista
          // this.itemActivo.institucion_id = oirs.institucion_id
        })
        .finally(() => {
          this.loading = false
        })
    },
    escalar() {
      this.loading = true
      this.dialogEscalarVisible = false
      this.$axios
        .patch(`documentacion/oirs/${this.itemActivo.id}`, this.formEscalar)
        .then((response) => {
          const oirs = response.data.data
          this.itemActivo.fecha_escalado = oirs.fecha_escalado
          this.itemActivo.mensaje_a_mesa_de_ayuda = oirs.mensaje_a_mesa_de_ayuda
        })
        .finally(() => {
          this.loading = false
        })
    },
    agregarMensaje() {
      this.loading = true
      this.dialogBitacoraVisible = false
      this.$axios
        .post(`documentacion/oirs/${this.itemActivo.id}/bitacoras`, this.form)
        .then((response) => {
          const bitacora = response.data.data
          this.itemActivo.bitacoras ??= []
          this.itemActivo.bitacoras.push(bitacora)
          this.itemActivo.updated_at = bitacora.updated_at
          this.itemActivo.estado = this.form.cerrar ? 10 : 1
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
